import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import API from "Signups/API";
import { getSignupErrorMessage } from "Signups/SharedComponents/getSignupErrorMessage";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks";
import { useSignups } from "Signups/state";
import { motion } from "framer-motion";

import FnrButton from "UI/FnrButton3";
import FnrConfirmationPopover from "UI/FnrConfirmationPopover";

import useHovering from "Utilities/Hooks/useHovering";

import DeletePaidSignupModal from "../../DeletePaidSignupModal";
import { personType } from "../../DeletePaidSignupModal/personType";

import HoverButton from "./HoverButton";
import DonationPill from "./SignupPayments/DonationPill";
import PaymentPill from "./SignupPayments/PaymentPill";

export default function AdditionalName({
  user,
  signupItemID,
  hasSignupCost,
  setRemovalType,
  removalType,
}) {
  const [state, dispatch] = useSignups();
  const [isHovering, hoverProps] = useHovering();
  const [status, setStatus] = useState(null);
  const [showDeletePopover, setShowDeletePopover] = useState(false);
  const confirmationRef = useRef();
  const [showDeletePaidSignupModal, setShowDeletePaidSignupModal] =
    useState(false);
  const isSuggestedDonation =
    state.currentSignupList?.fundIt?.isSuggestedDonation;
  const { getSignupItem } = signupItemStateHooks.useGetSignupItem();

  const displayName = () => {
    const { fname, lname } = user;
    return `${fname ? fname : ""} ${lname ? lname : ""}`;
  };

  const handleTrashCanClick = () => {
    if (hasSignupCost) {
      setRemovalType(personType.ADDITIONAL_NAME);
      setShowDeletePaidSignupModal(true);
      return;
    }

    toggleDeletePopover();
  };

  const toggleDeletePopover = () => setShowDeletePopover(!showDeletePopover);

  const handleDeleteClick = () => {
    setStatus("loading");
    API.removeAdditionalName({
      additionalNameID: user.additionalNameID,
      signupListID: state.currentSignupList.ID,
      signedUpViaID: 5,
    })
      .post()
      .then((resp) => {
        setStatus(null);
        getSignupItem(signupItemID);
        dispatch({
          type: "Other User Signup Updated",
          signupList: resp.signupList,
          allSignupLists: resp.allSignupLists,
        });
        toggleDeletePopover();
      })
      .catch((err) => {
        alert(getSignupErrorMessage(err?.error));
        setStatus(null);
        setShowDeletePopover(false);
      });
  };
  // console.log("user", user);

  return (
    <Wrapper {...hoverProps}>
      <Name>{displayName()}</Name>

      {hasSignupCost && isSuggestedDonation ? (
        <DonationPill
          amount={user?.paymentAmount}
          date={user?.paymentDate}
          status={user?.paymentStatus}
          markedPaidName={user?.markedPaidRecorderName}
          additionalNameID={user?.additionalNameID}
          userName={user?.name}
          payerName={user?.payerName}
          payerUserID={user?.payerUserID}
          style={{ marginLeft: "8px" }}
          name={displayName()}
          signupItemID={signupItemID}
          parentComponent="AdditionalName"
          isHovering={isHovering}
          isSuggestedDonation={isSuggestedDonation}
        />
      ) : hasSignupCost ? (
        <PaymentPill
          amount={user?.paymentAmount}
          date={user?.paymentDate}
          status={user?.paymentStatus}
          markedPaidName={user?.markedPaidRecorderName}
          additionalNameID={user?.additionalNameID}
          signupItemID={signupItemID}
          userName={user?.name}
          payerName={user?.payerName}
          style={{ marginLeft: "8px" }}
          name={displayName()}
          parentComponent="AdditionalName"
        />
      ) : null}

      <div ref={confirmationRef} style={{ marginLeft: "8px" }}>
        <HoverButton
          icon={faTrashAlt}
          isHovering={isHovering || showDeletePopover}
          isActive={showDeletePopover}
          onClick={handleTrashCanClick}
        />
      </div>

      <FnrConfirmationPopover
        show={showDeletePopover}
        ref={confirmationRef}
        onClose={() => setShowDeletePopover(false)}
        message={`Are you sure you want to remove ${displayName()} from the Signup?`}
        button1={
          <FnrButton
            text="Yes please!"
            onClick={handleDeleteClick}
            color="red"
            loading={status === "loading"}
          />
        }
        color="red"
        style={{ maxWidth: 200, padding: 10 }}
      />

      <DeletePaidSignupModal
        additionalName={user}
        signupItemID={signupItemID}
        showDeletePaidSignupModal={showDeletePaidSignupModal}
        setShowDeletePaidSignupModal={setShowDeletePaidSignupModal}
        removalType={removalType}
        setRemovalType={setRemovalType}
      />
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  font-size: 14px;
  font-style: italic;
  margin: 2px 0 2px 14px;
  display: flex;
  align-items: center;
`;

const Name = styled.div`
  cursor: default;
  margin-right: 3px;
  color: #333;
  font-weight: 400;
`;
